import React, { useEffect, useRef } from 'react';
import { Box } from '../../../Box';
import { mergeClassNames } from '../../../../utils/cssClassNameHelper';
import { dataTableClassnames } from '../const/classNames';
import { useDataTableContext } from '../context/DataTableContext';
import { Loading, LoadingBar } from './Loading';
import { HeaderRows } from './row/HeaderRows';
import { NoResults } from './row/NoResults';
import { Rows } from './row/Rows';
import { useMeasure } from '../../../../utils/useMeasure';

export const Table: React.FC = () => {
  const { tableInstance, state, slotProps } = useDataTableContext();
  const rows = tableInstance.getRowModel().rows;
  const loading = state.loading;
  const empty = !state.loading && rows.length === 0;
  const rootTableRef = useRef<HTMLDivElement>(null);
  const [{ ref }, { height: tableBodyHeight }] = useMeasure();

  useEffect(() => {
    if (loading) {
      rootTableRef.current?.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [loading]);

  return (
    <Box
      className={mergeClassNames(dataTableClassnames.table.root, {
        [dataTableClassnames.table.state.loading]: loading,
        [dataTableClassnames.table.state.empty]: empty
      })}
      role="grid"
      ref={rootTableRef}
    >
      <Loading loading={state.loading} />
      <LoadingBar loading={state.loadingInBackground} />
      <Box className={dataTableClassnames.table.head} role="presentation">
        <HeaderRows
          headerGroups={tableInstance.getHeaderGroups()}
          resize={!!tableInstance.options.enableColumnResizing}
          tableBodyHeight={tableBodyHeight}
        />
      </Box>

      <Box
        ref={ref}
        className={mergeClassNames(dataTableClassnames.table.body, {
          loading,
          empty
        })}
        role="presentation"
      >
        <Rows rows={tableInstance.getRowModel().rows} slotProps={slotProps} />
        {!state.loading && !rows.length && <NoResults />}
      </Box>
    </Box>
  );
};
